import React, { useState } from "react";
import ApplyNewLoan from "./ApplyNewLoan";
import {
  STATUS_NEW,
  STATUS_IN_PROGRESS,
  STATUS_APPROVED,
  STATUS_REJECTED,
  STATUS_PROCESSED,
  LOAN_CURRENCY_TYPE_BHD,
  SERVICE_REQUEST_NEW_LOAN,
  SERVICE_REQUEST_EXTEND_TENURE,
  SERVICE_REQUEST_PRE_CLOSURE,
  SERVICE_REQUEST_PARTIAL_PRE_PAYMENT,
  STATUS_CLOSED,
  LOAN_REPAYMENT_BY_BUSINESS,
  LOAN_CURRENCY_TYPE_USD,
  LOAN_WAIVER_APPLIED
} from "../utilities";
import Table from "react-bootstrap/Table";
import ExtendTenureDate from "./ExtendTenureDate";
import { useEffect } from "react";
import moment from "moment";
import TableData from "./../AdminFlow/TableData";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import Cookies from 'js-cookie';
import axios from ".././axios-interceptor";
import { base_url } from "./../utilities";
const EachLoanBreakUp = (props) => {
  let {business_name} = props
  const navigate = useNavigate();
 
  useEffect(() => {
    if (!Cookies.get("User_Accesstoken_Business")) {
      navigate("/");
    }
  }, []);

  const [activeTab, setActiveTab] = useState("home-tab");

  const columns = [
    {
      title: "Investment Payment",
      field: "tenure_amount",
      currency: "admin_request_loan_currency",
    },
    { title: "Tenure Date", field: "tenure_date" },
    {
      title: "Amount Repaid",
      field: "paid_amount",
      currency: "admin_request_loan_currency",
    },
    {
      title: "Excess Due",
      field: "penalty_amount",
      currency: "admin_request_loan_currency",
    },
  ];

  let loanDetails = props.loandata;

  let refNumber = props.loanrefno;
  let loan_history_array = [];

  let filteredRefNo = [];
  loanDetails.map((loan) => {
    if (refNumber === loan.loan_reference_number) {
      if (loan.loan_history !== undefined)
        loan.loan_history.map((each_history_record) => {
          //NEW LOAN REQUEST LIST
          if (
            each_history_record.status == STATUS_NEW &&
            each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
          ) {
            let message = "Business requested loan";
            let created_date_time = each_history_record.created_date_time;
            let message_object = {
              message: message,
              created_date_time: created_date_time,
            };
            loan_history_array.push(message_object);
          }
          if (
            !each_history_record.is_investor_interested &&
            !each_history_record.is_admin_sent_terms_to_business
          ) {
            if (
              each_history_record.status == STATUS_IN_PROGRESS &&
              each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
            ) {
              let message =
                "Admin filled the profit percentage and sent to investors";
              let created_date_time = each_history_record.created_date_time;
              let message_object = {
                message: message,
                created_date_time: created_date_time,
              };
              loan_history_array.push(message_object);
            }
          }
          if (
            each_history_record.status == STATUS_REJECTED &&
            each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
          ) {
            let message = "Admin rejected the new loan request";
            let created_date_time = each_history_record.created_date_time;
            let message_object = {
              message: message,
              created_date_time: created_date_time,
            };
            loan_history_array.push(message_object);
          }
          if (
            each_history_record.status == STATUS_IN_PROGRESS &&
            each_history_record.is_investor_interested === 1 &&
            each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
          ) {
            let message = "Investor has shown interest on this loan";
            let created_date_time = each_history_record.created_date_time;
            let message_object = {
              message: message,
              created_date_time: created_date_time,
            };
            loan_history_array.push(message_object);
          }
          if (
            each_history_record.status == STATUS_IN_PROGRESS &&
            each_history_record.is_admin_sent_terms_to_business === 1 &&
            each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
          ) {
            let message =
              "Admin sent loan terms and awaiting for business response";
            let created_date_time = each_history_record.created_date_time;
            let message_object = {
              message: message,
              created_date_time: created_date_time,
            };
            loan_history_array.push(message_object);
          }

          if (
            each_history_record.status == STATUS_APPROVED &&
            each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
          ) {
            let message = "Business agreed the new loan request terms";
            let created_date_time = each_history_record.created_date_time;
            let message_object = {
              message: message,
              created_date_time: created_date_time,
            };
            loan_history_array.push(message_object);
          }

          if (
            each_history_record.status == STATUS_PROCESSED &&
            each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
          ) {
            let message = (
              <div className="style_loan_txt">
                Admin paid the requested loan amount{" "}
                <span
                  style={{ color: "black", marginTop: "2px" }}
                  className="ps-1 pe-1 fw-bold"
                >
                  {each_history_record.paid_currency +
                    " " +
                    Number(each_history_record.paid_amount).toLocaleString()}
                </span>{" "}
                to business on{" "}
                <span
                  style={{ color: "black", marginTop: "2px" }}
                  className="ps-1 pe-1 fw-bold"
                >
                  {moment(each_history_record.paid_date).format("DD MMM YYYY")}
                </span>
              </div>
            );

            let created_date_time = each_history_record.created_date_time;
            let message_object = {
              message: message,
              created_date_time: created_date_time,
            };
            loan_history_array.push(message_object);
          }
          if (
            each_history_record.status == LOAN_REPAYMENT_BY_BUSINESS &&
            each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
          ) {
            let message = (
              <div className="">
                Business repaid for the month of{" "}
                <span style={{ color: "black" }} className="fw-bold">
                  {moment(each_history_record.tenure_date).format("MMMM")}
                </span>
                , loan tenure amount{" "}
                <span style={{ color: "black" }} className="fw-bold">
                  {each_history_record.paid_currency +
                    " " +
                    Number(each_history_record.paid_amount).toLocaleString()}
                </span>{" "}
                to admin on{" "}
                <span style={{ color: "black" }} className=" fw-bold">
                  {moment(each_history_record.paid_date).format("DD MMM YYYY")}
                </span>
              </div>
            );
            let created_date_time = each_history_record.created_date_time;
            let message_object = {
              message: message,
              created_date_time: created_date_time,
            };
            loan_history_array.push(message_object);
          }

          if (
            each_history_record.status == STATUS_NEW &&
            each_history_record.service_type_code ==
              SERVICE_REQUEST_EXTEND_TENURE
          ) {
            let message = "Business requested to extend loan tenure";
            let created_date_time = each_history_record.created_date_time;
            let message_object = {
              message: message,
              created_date_time: created_date_time,
            };
            loan_history_array.push(message_object);
          }
          if (
            each_history_record.status == STATUS_APPROVED &&
            each_history_record.service_type_code ==
              SERVICE_REQUEST_EXTEND_TENURE
          ) {
            let message = "Admin approved extend tenure request";
            let created_date_time = each_history_record.created_date_time;
            let message_object = {
              message: message,
              created_date_time: created_date_time,
            };
            loan_history_array.push(message_object);
          }

          if (
            each_history_record.status == STATUS_REJECTED &&
            each_history_record.service_type_code ==
              SERVICE_REQUEST_EXTEND_TENURE
          ) {
            let message = "Admin rejected the extend tenure request";
            let created_date_time = each_history_record.created_date_time;
            let message_object = {
              message: message,
              created_date_time: created_date_time,
            };
            loan_history_array.push(message_object);
          }

          if (
            each_history_record.status == STATUS_NEW &&
            each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
          ) {
            let message = "Business requested for pre closure of a loan";
            let created_date_time = each_history_record.created_date_time;
            let message_object = {
              message: message,
              created_date_time: created_date_time,
            };
            loan_history_array.push(message_object);
          }
          if (
            each_history_record.status == STATUS_APPROVED &&
            each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
          ) {
            let message = "Admin approved pre closure request";
            let created_date_time = each_history_record.created_date_time;
            let message_object = {
              message: message,
              created_date_time: created_date_time,
            };
            loan_history_array.push(message_object);
          }
          if (
            each_history_record.status == STATUS_REJECTED &&
            each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
          ) {
            let message = "Admin rejected pre closure request";
            let created_date_time = each_history_record.created_date_time;
            let message_object = {
              message: message,
              created_date_time: created_date_time,
            };
            loan_history_array.push(message_object);
          }
          if (
            each_history_record.status == STATUS_NEW &&
            each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
          ) {
            let message = "Business requested for partial pre-payment of a loan";
            let created_date_time = each_history_record.created_date_time;
            let message_object = {
              message: message,
              created_date_time: created_date_time,
            };
            loan_history_array.push(message_object);
          }
          if (
            each_history_record.status == STATUS_APPROVED &&
            each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
          ) {
            let message = "Admin approved partial pre-payment request";
            let created_date_time = each_history_record.created_date_time;
            let message_object = {
              message: message,
              created_date_time: created_date_time,
            };
            loan_history_array.push(message_object);
          }
          if (
            each_history_record.status == STATUS_REJECTED &&
            each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
          ) {
            let message = "Admin rejected partial pre-payment request";
            let created_date_time = each_history_record.created_date_time;
            let message_object = {
              message: message,
              created_date_time: created_date_time,
            };
            loan_history_array.push(message_object);
          }
          if (each_history_record.status == STATUS_CLOSED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
            let message = "Business repaid the loan successfully"
            let created_date_time = each_history_record.created_date_time;
            let message_object = {
              message: message,
              created_date_time: created_date_time,
            };
            loan_history_array.push(message_object);
          }
          if (each_history_record.status == LOAN_WAIVER_APPLIED) {
            let message = (
              <div>
                Charge Waiver applied —{' '}
                <span style={{ color: 'black' }} className="fw-bold">
                  BHD {Number(each_history_record.waiver_amount).toLocaleString()}
                </span>
                {' '}({each_history_record.waiver_type}) by{' '}
                <span style={{ color: 'black' }} className="fw-bold">
                  {each_history_record.approved_by}
                </span>
              </div>
            )
            let created_date_time = each_history_record.created_date_time;
            loan_history_array.push({ message, created_date_time })
          }
        });
      filteredRefNo.push(loan);
    }
  });
  const [modalShow, setModalShow] = React.useState(false);
  const [extendShow, setExtendShow] = React.useState(false);

  const goBacktoMyloans = () => {
    props.hide();
    props.showcontent();
  };
  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });

  const [paymentSchedules, setPaymentSchedules] = useState([]);
  const [charges, setCharges] = useState([])
  const [chargesLoading, setChargesLoading] = useState(false)

  const currentLoanId = filteredRefNo.length > 0 ? filteredRefNo[0]?.loan_id : null;

  useEffect(() => {
    const schedules =
      filteredRefNo.length > 0 ? filteredRefNo[0]?.my_payment_schedules : [];
    setPaymentSchedules(schedules);
  }, [refNumber]);

  useEffect(() => {
    if (currentLoanId) {
      setChargesLoading(true)
      axios
        .post(base_url + 'loan-charges/get_charges_by_loan', {
          loan_id: currentLoanId
        })
        .then(res => {
          if (res.data.status === 200) setCharges(res.data.data)
        })
        .catch(err => console.log(err))
        .finally(() => setChargesLoading(false))
    }
  }, [currentLoanId])

  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...paymentSchedules].sort((a, b) => {
      const columnA =
        column === "paid_amount" ? parseInt(a[column]) : a[column];
      const columnB =
        column === "paid_amount" ? parseInt(b[column]) : b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setPaymentSchedules(sortedData);
  };

  function exportToExcel() {
    let sample_data_array = [];
    paymentSchedules.forEach((elem) => {
      let xl_object = {
        "Investment Payment":
          elem.admin_request_loan_currency == LOAN_CURRENCY_TYPE_USD
            ? "$ " + elem.tenure_amount
            : LOAN_CURRENCY_TYPE_BHD + " " + elem.tenure_amount,
        "Tenure Date": moment(elem.tenure_date).format("DD MMM YYYY"),
        "Amount Repaid":
          elem.paid_amount == null
            ? "-"
            : elem.admin_request_loan_currency == LOAN_CURRENCY_TYPE_USD
            ? "$ " + elem.paid_amount
            : LOAN_CURRENCY_TYPE_BHD + " " + elem.paid_amount,
        "Excess Due":
          elem.penalty_amount == null
            ? "-"
            : elem.admin_request_loan_currency == LOAN_CURRENCY_TYPE_USD
            ? "$ " + elem.penalty_amount
            : LOAN_CURRENCY_TYPE_BHD + " " + elem.penalty_amount,
      };
      sample_data_array.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = sample_data_array;

    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);

    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    // const fileExtension = ".xlsx";
    const fileName = business_name+"_Loan_Schedules_Statement.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }
  return (
    <div>
      <div className="col px-5 py-3 db_body">
        <div className="row ">
          <div className="col d-flex justify-content-between">
            <div className="">
              <h1 onClick={goBacktoMyloans} className="Cpointer mb-0">
                <img src="./images/left_arrow.svg" alt="" />
                &nbsp; Loan Reference No.{" "}
                <span className="ml_lrn">{props.loanrefno}</span>{" "}
              </h1>
            </div>
            <div>
              <button
                className="btn blue_btn"
                onClick={() => setModalShow(true)}
              >
                Apply New Loan
              </button>
            </div>
          </div>
        </div>
        <ApplyNewLoan show={modalShow} onHide={() => setModalShow(false)} />

        <div className="card mt-3">
          <div className="ml_indiv_loan_dtls ">
            <h4 className="mb-0 sesame-color">Loan Details</h4>
            {filteredRefNo.map((details) => {
              return (
                <div key={details._id} className="row pt-0">
                  <div className="col-xs-4 col-lg-3 me-4">
                    <label htmlFor="">Loan Purpose</label>
                    <h3>
                      {details.loan_purpose === undefined
                        ? "-"
                        : details.loan_purpose}
                    </h3>
                  </div>

                  <div className="col-xs-3 col-lg-2 me-3">
                    <label htmlFor="">Principal Amount</label>
                    <h3>
                      {details.loan_amount === null ||
                      details.loan_amount === undefined ||
                      details.loan_amount === ""
                        ? "-"
                        : details.admin_request_loan_currency ===
                          LOAN_CURRENCY_TYPE_BHD
                        ? "BHD " + Number(details.loan_amount).toLocaleString()
                        : "$ " + Number(details.loan_amount).toLocaleString()}
                    </h3>
                  </div>

                  <div className="col-xs-3 col-lg-2 ms-3">
                    <label htmlFor="">Monthly Rate</label>
                    <h3>
                      {details.bennefin_roi === null ||
                      details.bennefin_roi === undefined
                        ? "-"
                        : details.bennefin_roi + "%"}
                    </h3>
                  </div>

                  <div className="col-xs-2 col-lg-2 ms-3">
                    <label htmlFor="">Tenure</label>
                    <h3>
                      {details.loan_tenure == 1
                        ? details.loan_tenure + " Month"
                        : details.loan_tenure > 1
                        ? details.loan_tenure + " Months"
                        : details.loan_tenure < 1
                        ? "-"
                        : ""}{" "}
                    </h3>
                  </div>

                  <div className="col-xs-3 col-lg-2">
                    <label htmlFor="">Status</label>
                    <h3>
                      {details.status === STATUS_NEW
                        ? "New"
                        : details.status === STATUS_IN_PROGRESS
                        ? "In progress"
                        : details.status === STATUS_APPROVED
                        ? "Approved"
                        : details.status === STATUS_REJECTED
                        ? "Rejected"
                        : details.status === STATUS_PROCESSED
                        ? "Processed"
                        : details.status === STATUS_CLOSED
                        ? "Closed"
                        : "-"}
                    </h3>
                  </div>

                  <div className="col-xs-4 col-lg-3 me-4">
                    <label htmlFor="">Interest Frequency</label>
                    <h3>
                      {details.interest_frequency === null ||
                      details.interest_frequency === undefined
                        ? "-"
                        : details.interest_frequency}
                    </h3>
                  </div>

                  <div className="col-lg-2">
                    <label htmlFor="">Principal Frequency</label>
                    <h3>
                      {details.principal_frequency === null ||
                      details.principal_frequency === undefined
                        ? "-"
                        : details.principal_frequency}
                    </h3>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="row bg-white ml_table_footer">
            <div className="col ">
              <ul
                className="nav nav-tabs d-flex busns_each_ln_pop"
                id="myTab"
                role="tablist"
              >
                <li className="nav-item me-3" role="presentation">
                  <button
                    className="nav-link active p-1"
                    id="home-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#home-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="home-tab-pane"
                    aria-selected="true"
                    onClick={() => setActiveTab("home-tab")}
                  >
                    <h6 className="">Schedule Of Return Payments</h6>
                    {activeTab === "home-tab" && (
                      <img
                        style={{ marginTop: "-47px" }}
                        src="./images/polygondown.svg"
                        alt=""
                      />
                    )}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link p-1"
                    id="profile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#profile-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="profile-tab-pane"
                    aria-selected="false"
                    onClick={() => setActiveTab("profile-tab")}
                  >
                    <h6>Loan History</h6>
                    {activeTab === "profile-tab" && (
                      <img
                        style={{ marginTop: "-47px" }}
                        src="./images/polygondown.svg"
                        alt=""
                      />
                    )}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link p-1"
                    id="charges-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#charges-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="charges-tab-pane"
                    aria-selected="false"
                    onClick={() => setActiveTab("charges-tab")}
                  >
                    <h6>Additional Charges</h6>
                    {activeTab === "charges-tab" && (
                      <img
                        style={{ marginTop: "-47px" }}
                        src="./images/polygondown.svg"
                        alt=""
                      />
                    )}
                  </button>
                </li>
              </ul>
            </div>

            <div className="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="home-tab-pane"
                role="tabpanel"
                aria-labelledby="home-tab"
                tabIndex="0"
              >
                <div className="mt-2 eachloan_table">
                  <Table striped className="my_loan_table">
                    <thead>
                      <tr>
                        {columns.map((col, id) => (
                          <th key={id} className="Cpointer"
                            onClick={() => handleSort(col.field)}>
                            {col.title} &#9662;
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {paymentSchedules?.map((data, index) => (
                        <React.Fragment key={index}>
                          <tr>
                            <td>
                              {data.admin_request_loan_currency === LOAN_CURRENCY_TYPE_USD
                                ? '$ ' : 'BHD '}
                              {Number(data.tenure_amount).toLocaleString()}
                            </td>
                            <td>{moment(data.tenure_date).format('DD MMM YYYY')}</td>
                            <td>
                              {data.paid_amount == null ? '-' : (
                                (data.admin_request_loan_currency === LOAN_CURRENCY_TYPE_USD
                                  ? '$ ' : 'BHD ') + data.paid_amount
                              )}
                            </td>
                            <td>
                              {data.penalty_amount == null || data.penalty_amount == 0
                                ? 'BHD 0'
                                : (data.admin_request_loan_currency === LOAN_CURRENCY_TYPE_USD
                                  ? '$ ' : 'BHD ') + data.penalty_amount}
                            </td>
                          </tr>

                          {/* Charge Waiver row — shown if waived_amount exists */}
                          {Number(data.waived_amount) > 0 && (
                            <tr style={{ background: '#EAF3DE' }}>
                              <td style={{ color: '#3B6D11', paddingLeft: 24 }}>
                                Charge Waiver
                              </td>
                              <td style={{ color: '#3B6D11' }}>
                                {moment(data.tenure_date).format('DD MMM YYYY')}
                              </td>
                              <td style={{ color: '#3B6D11' }}>
                                BHD {Number(data.waived_amount).toFixed(2)}
                              </td>
                              <td style={{ color: '#3B6D11' }}>
                                —
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </Table>
                </div>

                <ExtendTenureDate
                  loanrefnum={props.loanrefno}
                  show={extendShow}
                  onHide={() => setExtendShow(false)}
                />
              </div>
              <div
                className="tab-pane fade loan_history_tab"
                id="profile-tab-pane"
                role="tabpanel"
                aria-labelledby="profile-tab"
                tabIndex="0"
              >
                {loan_history_array.length === 0 ? (
                  <h3 className="text-center mt-4">
                    There are no previous closed loans for this Business
                  </h3>
                ) : (
                  loan_history_array.map((details) => {
                    return (
                      <div key={details.message} className="row pt-0">
                        <div className="style_loan">
                          <img
                            className="me-2"
                            src="./images/circle.svg"
                            alt=""
                            srcSet=""
                            height={16}
                            width={16}
                          />
                          {moment(details.created_date_time).format(
                            "ddd, D MMM YYYY"
                          )}
                        </div>
                        <div className="style_loan_txt mb-4 ms-4 pe-5">
                          {details.message}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>

              {/* Additional Charges Tab */}
              <div
                className="tab-pane fade"
                id="charges-tab-pane"
                role="tabpanel"
                aria-labelledby="charges-tab"
                tabIndex="0"
              >
                <div className="p-3">
                  {chargesLoading ? (
                    <div className="text-center mt-3" style={{ fontSize: 13, color: '#888' }}>
                      Loading...
                    </div>
                  ) : charges.length === 0 ? (
                    <div className="text-center mt-4" style={{ fontSize: 13, color: '#888' }}>
                      No additional charges for this loan.
                    </div>
                  ) : (
                    <table className="table table-striped" style={{ fontSize: 13 }}>
                      <thead>
                        <tr>
                          <th>Charge Type</th>
                          <th>Description</th>
                          <th>Amount</th>
                          <th>Charge Date</th>
                          {/* <th>Status</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {charges.map((charge, index) => (
                          <tr key={index}>
                            <td>{charge.charge_type}</td>
                            <td>{charge.description || '—'}</td>
                            <td>BHD {Number(charge.charge_amount).toFixed(2)}</td>
                            <td>{moment(charge.charge_date).format('DD MMM YYYY')}</td>
                            {/* <td>
                              {charge.is_checked === 1 ? (
                                <span style={{
                                  fontSize: 11, color: '#3B6D11',
                                  background: '#EAF3DE', border: '1px solid #C0DD97',
                                  borderRadius: 4, padding: '2px 6px'
                                }}>
                                  ✓ Verified
                                </span>
                              ) : (
                                <span style={{
                                  fontSize: 11, color: '#854F0B',
                                  background: '#FAEEDA', border: '1px solid #FAC775',
                                  borderRadius: 4, padding: '2px 6px'
                                }}>
                                  Pending
                                </span>
                              )}
                            </td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>

            <div className="justify-content-end d-flex px-3 gap-4">
              {filteredRefNo.map((status) => {
                if (
                  status.status === STATUS_PROCESSED &&
                  status.is_extend_tenure_raised == 0
                ) {
                  // "At least one installment paid" check removed as a hotfix so bullet loans can be extended
                  return (
                    <button
                      className="btn blue_btn mt-3"
                      onClick={() => setExtendShow(true)}
                    >
                      Extend Tenure
                    </button>
                  );
                }
              })}

              <button onClick={exportToExcel} className="btn blue_btn mt-3">
                Download Statement
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EachLoanBreakUp;